import {
    SET_CUSTOMER_SOURCING_LANES,
    SET_SELECTED_CUSTOMER_SOURCING_LANE,
    SET_CUSTOMER_SOURCING_LANES_LOADING,
    SET_CUSTOMER_SOURCING_LANES_ERROR,
    UPSERT_CUSTOMER_SOURCING_LANE,
    REMOVE_CUSTOMER_SOURCING_LANE
} from './actionTypes'

const initialState = {
    byId: {},
    allIds: [],
    selectedId: null,
    loading: false,
    error: null
}

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_CUSTOMER_SOURCING_LANES: {
        const byId = {}
        const allIds = []

        for (const lane of (action.lanes || [])) {
            byId[lane.id] = lane
            allIds.push(lane.id)
        }

        return {
            ...state,
            byId,
            allIds,
            loading: false,
            error: null
        }
    }

    case SET_SELECTED_CUSTOMER_SOURCING_LANE:
        return {
            ...state,
            selectedId: action.id || null
        }

    case SET_CUSTOMER_SOURCING_LANES_LOADING:
        return {
            ...state,
            loading: action.loading
        }

    case SET_CUSTOMER_SOURCING_LANES_ERROR:
        return {
            ...state,
            loading: false,
            error: action.error
        }

    case UPSERT_CUSTOMER_SOURCING_LANE: {
        const lane = action.lane
        if (!lane?.id) return state

        const exists = !!state.byId[lane.id]

        return {
            ...state,
            byId: {
                ...state.byId,
                [lane.id]: {
                    ...state.byId[lane.id],
                    ...lane
                }
            },
            allIds: exists ? state.allIds : [...state.allIds, lane.id],
            error: null
        }
    }

    case REMOVE_CUSTOMER_SOURCING_LANE: {
        const id = action.id
        if (!id || !state.byId[id]) return state

        const byId = {...state.byId}
        delete byId[id]

        return {
            ...state,
            byId,
            allIds: state.allIds.filter(laneId => laneId !== id),
            selectedId: state.selectedId === id ? null : state.selectedId
        }
    }

    default:
        return state
    }
}

export { initialState }